import { FILTER_TYPES } from 'components/FilterPod';
import jMoment from 'moment-jalaali';

const filters = (businessGuildsList = [] , currencyText) => [
  {
    title: 'محدوده تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date()).subtract(7, 'days'),
      end: jMoment(new Date()),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
  {
    title: 'حساب تفصیلی کسب‌وکار',
    label: 'حساب تفصیلی کسب‌وکار',
    keyName: 'شناسه صنف',
    query: 'id',
    id: 1576,
    value: null,
    filterType: FILTER_TYPES.autocomplete,
    getValueLabel: (v) => v?.label ?? v?.name ?? '',
    filterProps: {
      list: businessGuildsList,
    },
  },
 
  {
    title: 'محدوده‌ مبلغ درآمد',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'محدوده‌ مبلغ درآمد',
    id: {
      start: 1578,
      end: 1579,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
];

export default filters;
